module.exports = __webpack_public_path__ + "media/images/flags/tv-34f3f20283179d4f7a61acb9a8ece100.svg";